import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

export const LeftArrow = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 18 16"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path className={fillStyles} id="yj673rfuqa" d="m4.5 7 5.6-5.6L8.7 0l-8 8 8 8 1.4-1.4L4.5 9h12.2V7z" />
            </defs>
            <g transform="translate(.857)" fill="none" fillRule="evenodd">
                <mask id="so5mf371zb" fill="#fff">
                    <use xlinkHref="#yj673rfuqa" />
                </mask>
                <use fill="#059BFC" xlinkHref="#yj673rfuqa" />
                <g mask="url(#so5mf371zb)" fill="#FFF">
                    <path d="M-3-4h24v24H-3z" />
                </g>
            </g>
        </svg>
    );
};
